import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  GetwalletByIdRequest,
  GetWalletByIdResponse,
} from "./types";
import { baseQueryCreator } from "redux/baseQuery";
import env from "env";
import { GetTransactionsRequest, GetTransactionsResponse } from "../wallet/types";

const { accountService } = env.api.baseUrl;

const baseQuery = fetchBaseQuery({
  baseUrl: accountService,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as any).auth.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const accountApi = createApi({
  reducerPath: "accountApi",
  baseQuery: baseQueryCreator(baseQuery),
  refetchOnMountOrArgChange: true,
  tagTypes: ["Accounts"],
  endpoints: (builder) => ({
    getWalletByOrgId: builder.query<GetWalletByIdResponse, GetwalletByIdRequest>({
      query: ({orgId, orgToken }) => {
        if(orgToken) {
          return {
            url: `wallets`,
            method: "GET",
            headers: {
              'org-token':orgToken
            },
            params: {
              orgId
            }
          }
        } 
      return {
        url: `wallets`,
        method: "GET",
        params: {
          orgId
        }
      }}
    }),
     getTransactionHistory: builder.query<
      GetTransactionsResponse,
      GetTransactionsRequest
    >({
      query: (params) => {
        return {
          url: `transactions`,
          method: "GET",
          params: {
            ...params
          },
        };
      },
    }),
  }),
});

export const {
  useGetWalletByOrgIdQuery,
  useGetTransactionHistoryQuery
} = accountApi;
export const { useQueryState: useGetWalletByOrgIdQueryState } =
  accountApi.endpoints.getWalletByOrgId;